angular.module('Itao.IndicatorMap').directive('indicatorDataLayerTypes', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerTypes.html',
    restrict: 'E',
    scope: {
      types: '=',
      selectedDataLayerType: '=',
      layers: '=',
      onDataLayerTypeSelect: '&'
    },
    link: function (scope) {
      scope.config = {
        typeUid: 0
      };

      scope.$watch('config.typeUid', function (selectedTypeUid) {
        if(!selectedTypeUid) return;
        angular.forEach(scope.types, function(type) {
          if(type.uid == selectedTypeUid && selectedTypeUid != scope.selectedDataLayerType.uid) {
            scope.onDataLayerTypeSelect({dataLayerType: type});
          }
        });
      });

      scope.$watch('selectedDataLayerType.uid', function (selectedTypeUid) {
          scope.config.typeUid = selectedTypeUid;
      });
    }
  };
});
